export default "__VITE_ASSET__Bq0MMpIW__"